export default "__VITE_ASSET__CUSoDIBA__"